export default __webpack_public_path__ + "static/media/SIDM.cc043f7d.png";